import type {BillingTermsFormValues, ManualBillableLineItemInput} from '../jobs/types'

export type CreateProjectFormValues = {
    customerId: string | null
    customerName: string | null
    name: string
    description: string
    notes: string
    internalContactId: string | null
    customerContactId: string | null
    billingMethod: ProjectBillingMethod
    billingTerms: BillingTermsFormValues
    manualBillableLineItems: ManualBillableLineItemInput[]
    cloneProjectId: string | null
    quoteId: string | null
}

export type ProjectBillingMethod = 'line_rates' | 'hourly_transportation' | 'flat_rate' | 'per_load'

export function createInitialFormValues(
    currentUserId: string | null = null,
): CreateProjectFormValues {
    return {
        customerId: null,
        customerName: null,
        name: '',
        description: '',
        notes: '',
        internalContactId: currentUserId,
        customerContactId: null,
        billingMethod: 'line_rates',
        billingTerms: createInitialBillingTermsFormValues(),
        manualBillableLineItems: [],
        cloneProjectId: null,
        quoteId: null,
    }
}

export function createInitialBillingTermsFormValues(): BillingTermsFormValues {
    return {
        transportationHourlyRate: null,
        flatRateAmount: null,
        ratePerLoad: null,
        perLoadNotes: '',
        demurrageHourlyRate: null,
        disposalFees: [],
        washoutFee: null,
        hseiPercent: null,
        managerApprovedBelowMinimumRate: false,
    }
}
